import API from './api';

/**************************************************
 IMPORTANT : ne pas utiliser directement les API
 vous devez utiliser les services à la place
 **************************************************/

const exportedObject = {

  get (id, params) {
    return API.get('/orders/items/' + id, { params })
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  getAll (params) {
    return API.get('/orders/items', { params })
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  create (id_order, data) {
    return API.post('/orders/' + id_order + '/items', data)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  update (id, data) {
    return API.post('/orders/items/' + id, data)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  delete (id) {
    return API.delete('/orders/items/'  +id)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  set (id_order, order_items = []) {
    return API.post('/orders/' + id_order + '/items/bulk/', {order_items})
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
}

export default exportedObject;
